module.exports = __webpack_public_path__ + "static/media/hanley.ab282931.png";